import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@primer/react';
import { isEnterOrSpacePressed, focusTabOnArrow } from '../../utils/functions.js';
import CollapseDownIcon from '../../icons/collapseDownIcon.js';
import CollapseUpIcon from '../../icons/collapseUpIcon.js';

var AccordionSectionTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 0;\n  margin-left: 15px;\n  overflow: hidden;\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 0;\n  margin-left: 15px;\n  overflow: hidden;\n"])), themeGet("colors.text.default"));
var AccordionHeadingWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n"], ["\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n"])));
var AccordionHeaderSectionComponent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: auto;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: auto;\n"])), themeGet("colors.text.muted"));
var AccordionSectionHeader = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  height: 45px;\n  max-height: 50px;\n  padding: 6px 16px;\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  height: 45px;\n  max-height: 50px;\n  padding: 6px 16px;\n"])), themeGet("colors.fg.onEmphasis"), themeGet("colors.border.default"));
var AccordionSectionAction = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  margin-left: 15px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin-left: 15px;\n"])));
var AccordionSectionDataWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-top: none;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 8px 16px;\n  @media screen and (max-width: 1024px) {\n    min-height: 100px;\n  }\n"], ["\n  border: 1px solid ", ";\n  border-top: none;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 8px 16px;\n  @media screen and (max-width: 1024px) {\n    min-height: 100px;\n  }\n"])), themeGet("colors.border.default"));
var LTAccordionWrapper = function LTAccordionWrapper(_a) {
  var _b = _a.childExtraStyle,
    childExtraStyle = _b === void 0 ? {} : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    _d = _a.isMultiOpen,
    isMultiOpen = _d === void 0 ? false : _d,
    _e = _a.headerExtraStyle,
    headerExtraStyle = _e === void 0 ? {} : _e,
    _f = _a.options,
    options = _f === void 0 ? [] : _f,
    _g = _a.tabIndex,
    tabIndex = _g === void 0 ? 0 : _g;
    _a.children;
  var _h = useState({}),
    expandIndex = _h[0],
    setExpandIndex = _h[1];
  var accordionRefs = useRef(options.map(function () {
    return /*#__PURE__*/React.createRef();
  }));
  var handleKeyDown = function handleKeyDown(e, index) {
    var refLength = accordionRefs.current.length;
    if (isEnterOrSpacePressed(e)) {
      onExpandChange(index);
    } else {
      focusTabOnArrow(e, "vertical", accordionRefs, index, refLength - 1);
    }
  };
  var onExpandChange = function onExpandChange(index) {
    var _a, _b, _c, _d;
    if (isMultiOpen) {
      if (!expandIndex[index]) {
        setExpandIndex(__assign(__assign({}, expandIndex), (_a = {}, _a[index] = true, _a)));
      } else {
        setExpandIndex(__assign(__assign({}, expandIndex), (_b = {}, _b[index] = false, _b)));
      }
    } else {
      if (!expandIndex[index]) {
        setExpandIndex((_c = {}, _c[index] = true, _c), function (expandIndex) {
          return console.log(expandIndex);
        });
      } else {
        setExpandIndex((_d = {}, _d[index] = false, _d));
      }
    }
  };
  return options.map(function (_a, index) {
    var childSectionComponent = _a.childSectionComponent,
      leadingIcon = _a.leadingIcon,
      title = _a.title,
      headerSectionComponent = _a.headerSectionComponent,
      isExpanded = _a.isExpanded;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionSectionHeader, {
      "aria-expanded": expandIndex[index],
      ref: function ref(el) {
        return accordionRefs.current[index] = el;
      },
      onClick: function onClick() {
        return onExpandChange(index);
      },
      onKeyDown: function onKeyDown(e) {
        handleKeyDown(e, index);
      },
      tabIndex: tabIndex,
      className: className,
      style: __assign({}, headerExtraStyle),
      role: "button"
    }, /*#__PURE__*/React.createElement(AccordionHeadingWrapper, null, expandIndex[index] || isExpanded ? /*#__PURE__*/React.createElement(CollapseUpIcon, {
      style: {
        flexShrink: 0
      }
    }) : /*#__PURE__*/React.createElement(CollapseDownIcon, {
      style: {
        flexShrink: 0
      }
    }), leadingIcon && /*#__PURE__*/React.createElement(AccordionSectionAction, null, leadingIcon), title && /*#__PURE__*/React.createElement(AccordionSectionTitle, null, title)), headerSectionComponent && /*#__PURE__*/React.createElement(AccordionHeaderSectionComponent, null, headerSectionComponent)), (expandIndex[index] || isExpanded) && childSectionComponent && /*#__PURE__*/React.createElement(AccordionSectionDataWrapper, {
      id: "accordianChild-".concat(index),
      style: __assign({}, childExtraStyle)
    }, childSectionComponent));
  });
};
LTAccordionWrapper.propTypes = {
  className: PropTypes.string,
  options: PropTypes.object,
  tabIndex: PropTypes.number,
  title: PropTypes.string
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { LTAccordionWrapper as default };
